const UserRoutes = [
     {
        path: '/invite',
        name: 'PersonalCenter',
        component: () => import(/* webpackChunkName: "personalcenter" */'@/views/user/PersonalCenter.vue')
    },
     {
        path: '/point-redemption',
        name: 'ChatGPTAppleIdEN',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/user/PointRedemption.vue')
    }
]


export default UserRoutes;


